import { ContactSlugEnum } from '@systemeio/ui'
import UpdateFieldsModal from 'modules/contacts/components/update-fields-modal'
import { useManageCustomerFields } from 'modules/contacts/components/update-fields-modal/hooks/use-manage-customer-fields'
import { ManageFieldsInterface } from 'modules/contacts/components/update-fields-modal/types/manage-fields-interface'
import { useUpdateSubscriptionFields } from 'modules/profile/manage-subscriptions/hooks/use-update-subscription-fields'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

interface UpdateCustomerFieldsModalProps {
  opened: boolean
  onClose: () => void
  subscriptionId: number
}

function UpdateSubscriptionFieldsModal({
  opened,
  onClose,
  subscriptionId,
}: UpdateCustomerFieldsModalProps) {
  const { t } = useLocoTranslation()

  const { data, mutate, isLoadingFields } = useManageCustomerFields({
    subscriptionId,
    isFetchAllowed: opened,
  })

  const { updateSubscriptionFields, isFetchUpdate } = useUpdateSubscriptionFields({
    subscriptionId,
  })

  const removeUnusedFields = (data: ManageFieldsInterface | undefined) => {
    if (!data) return undefined

    return {
      ...data,
      fieldValues: data.fieldValues.filter(
        item =>
          ![ContactSlugEnum.Email, ContactSlugEnum.Country, ContactSlugEnum.TaxNumber].includes(
            item.contactField.slug as ContactSlugEnum,
          ),
      ),
    }
  }

  return (
    <UpdateFieldsModal
      opened={opened}
      onClose={onClose}
      data={data}
      mutate={mutate}
      isLoadingFields={isLoadingFields}
      isFetching={isFetchUpdate}
      updateFields={updateSubscriptionFields}
      title={t('dashboard.settings.manage_subscriptions.update_information')}
      unusedFields={removeUnusedFields}
    />
  )
}

export default UpdateSubscriptionFieldsModal
